export default "__VITE_ASSET__117yFUox__"